<template>
  <b-modal
    ref="confirmRevenuecatDisable"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable>

    <b-alert
      variant="light-danger"
      show
      class="mb-0">
      <p class="font-size-lg mb-0">
        Disabling RevenueCat integration may cause loss of account generation for subscriptions, leading to system malfunction and user service disruption. Please consider implications, ensuring alignment with your goals. Discuss with your team before proceeding.
      </p>
    </b-alert>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('confirmRevenuecatDisable')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="revenuecatResponses('switchRevenuecatStatus')"
          @click="switchRevenuecatStatus(), hideModal('confirmRevenuecatDisable')">
          Yes, turn it off
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  SWITCH_REVENUECAT_STATUS,
  GET_REVENUECAT_DATA
} from '@/core/services/store/reseller_revenuecat.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalDisableRevenuecat',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'integrationsList',
      'failedGetResellerStatus',
      'failedIntegrationGetStatus',
      'revenuecatIsEnabled',
      'revenuecatApikey',
      'revenuecatApikeyEmpty',
      'revenuecatPubkey',
      'revenuecatPubkeyEmpty',
      'revenuecatResponses'
    ]),

    routeId() {
      return this.$route.params.id
    },
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    switchRevenuecatStatus() {
      this.$store
        .dispatch(SWITCH_REVENUECAT_STATUS, { id: this.routeId })
        .then(() => {
          this.$store.dispatch(GET_REVENUECAT_DATA, { id: this.routeId })
        })
    }
  }
}
</script>
